import template from './four-o-four.template.html';
import './four-o-four.scss';

export default {
  template,
};



// WEBPACK FOOTER //
// ./src/app/four-o-four/four-o-four.component.js